export default {
  title: 'Sklep',
  fields: {
    has_reservations: {
      label: 'Wyświetlaj rezerwacje w sklepie',
    },
  },
  button: {
    save: 'Zapisz',
    preview: 'Podgląd',
  },
  no_storefront: {
    title: 'Nie znaleziono sklepu',
    description: 'Utwórz sklep.',
    button: {
      storefront: 'Przejdź do sklepu',
    },
  },
  response_messages: {
    success: 'Zaktualizowano pomyślnie.',
    failed: 'Aktualizacja nie powiodła się.',
  },
};
